import { FormControlOptions } from '@miq/catalog';

export const TenancyFormConfig: { [key: string]: FormControlOptions<any> } = Object.freeze({
  property_space: {
    name: 'property_space',
    type: 'array',
    controlsConfig: {
      id: [null],
      brand_id: [null],
    },
  },
  company_industry_classification: {
    name: 'company_industry_classification',
    type: 'array',
    controlsConfig: {
      _mode: [null],
      id: [null],
      primary_naics_code_f: [null],
    },
  },
});
